var render = function render(){var _vm=this,_c=_vm._self._c;return _c('be-alert',{attrs:{"icon-background":"","icon-text":`${_vm.roundedScore}%`,"color":_vm.color}},[_c('strong',{staticClass:"text-uppercase"},[_vm._v(_vm._s(_vm.title))]),_c('br'),_vm._v("\n    "+_vm._s(_vm.description)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }